export const ShopsNewIcon = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 13C11.207 15.3795 12 26 12 26C12 26 12.793 15.3795 23.5 13C12.793 10.6205 12 0 12 0C12 0 11.207 10.6205 0.5 13ZM16.5 23C18.1865 23.3251 19.7256 24.1788 20.8943 25.4374C22.063 26.696 22.8006 28.2941 23 30C23.1994 28.2941 23.937 26.696 25.1057 25.4374C26.2744 24.1788 27.8135 23.3251 29.5 23C27.8135 22.6749 26.2744 21.8212 25.1057 20.5626C23.937 19.304 23.1994 17.7059 23 16C22.8006 17.7059 22.063 19.304 20.8943 20.5626C19.7256 21.8212 18.1865 22.6749 16.5 23Z" fill="url(#paint0_linear_4318_41361)"/>
            <defs>
                <linearGradient id="paint0_linear_4318_41361" x1="15" y1="0" x2="15" y2="30" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FF7B42"/>
                <stop offset="1" stopColor="#FFE712"/>
                </linearGradient>
            </defs>
        </svg>
    );
};